import { useContext } from 'react';

import { type History } from 'history';

import AppConfigContext from './AppConfigContext';

export const useRouter: () => {
	contextSpaPaths: string[];
	contextEntryPoint: string;
	push: (url: string) => void;
	replace: (url: string) => void;
	history: History<unknown> | undefined;
} = () => {
	const { contextSpaPaths, contextEntryPoint, push, replace, history } =
		useContext(AppConfigContext);

	return { contextSpaPaths, contextEntryPoint, push, replace, history };
};
